export const feedConstants = {
  DELETE_FILE_REQUEST: 'FEED/DELETE_FILE_REQUEST',
  DELETE_FILE_SUCCESS: 'FEED/DELETE_FILE_SUCCESS',
  DELETE_FILE_FAILURE: 'FEED/DELETE_FILE_FAILURE',

  ADD_STAFF_ROLE_REQUEST: 'FEED/ADD_STAFF_ROLE_REQUEST',
  ADD_STAFF_ROLE_SUCCESS: 'FEED/ADD_STAFF_ROLE_SUCCESS',
  ADD_STAFF_ROLE_FAILURE: 'FEED/ADD_STAFF_ROLE_FAILURE',

  REMOVE_STAFF_ROLE_REQUEST: 'FEED/REMOVE_STAFF_ROLE_REQUEST',
  REMOVE_STAFF_ROLE_SUCCESS: 'FEED/REMOVE_STAFF_ROLE_SUCCESS',
  REMOVE_STAFF_ROLE_FAILURE: 'FEED/REMOVE_STAFF_ROLE_FAILURE',

  REMOVE_FROM_GROUP_REQUEST: 'FEED/REMOVE_FROM_GROUP_REQUEST',
  REMOVE_FROM_GROUP_SUCCESS: 'FEED/REMOVE_FROM_GROUP_SUCCESS',
  REMOVE_FROM_GROUP_FAILURE: 'FEED/REMOVE_FROM_GROUP_FAILURE',

  SELECTED_NEWSFEED: 'FEED/SELECTED_NEWSFEED',

  GET_FEED_CTA_REQUEST: 'FEED/GET_FEED_CTA_REQUEST',
  GET_FEED_CTA_SUCCESS: 'FEED/GET_FEED_CTA_SUCCESS',
  GET_FEED_CTA_FAILURE: 'FEED/GET_FEED_CTA_FAILURE',

  GET_NEW_MEMBERS_CTA_REQUEST: 'FEED/GET_NEW_MEMBERS_CTA_REQUEST',
  GET_NEW_MEMBERS_CTA_SUCCESS: 'FEED/GET_NEW_MEMBERS_CTA_SUCCESS',
  GET_NEW_MEMBERS_CTA_FAILURE: 'FEED/GET_NEW_MEMBERS_CTA_FAILURE'
}
